import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import initialState from "../initial-state";

// type InitAction = { time: number; elapsed?: number; historyURL?: string };

const realityCheck = createSlice({
  name: "realityCheck",
  initialState: initialState.realityCheck,
  reducers: {
    // initRealityCheck(state, action: PayloadAction<InitAction>) {
    //   if (!action.payload.time) return state;
    //
    //   const time = action.payload.time * 1000;
    //   const elapsed = !!action.payload.elapsed
    //     ? action.payload.elapsed * 1000
    //     : 0;
    //   const now = Date.now();
    //   const start = now - elapsed;
    //   const historyURL = action.payload.historyURL || "";
    //   const total = state.total !== 0 ? state.total : elapsed;
    //
    //   return { ...state, active: true, time, now, start, total, historyURL };
    // },
    // stopRealityCheck(state) {
    //   return { ...state, active: false };
    // },
    // realityCheckTick(state, action: PayloadAction<number>) {
    //   if (typeof action.payload !== "number" || !state.active) return state;
    //   const now = state.now + action.payload;
    //   const visible = now - state.start >= state.time;
    //   const total = state.total + action.payload;
    //
    //   return { ...state, now, total, visible };
    // },
    
    hideRealityCheck(state) {
      return {...state, visible: false }
    },
    setRealityCheck(
      state,
      action: PayloadAction<{ time: number; historyURL?: string }>
    ) {
      if (!action.payload.time || action.payload.time === 0) return state;
      return {
        ...state,
        visible: true,
        time: action.payload.time,
        historyURL: action.payload.historyURL ?? "",
      };
    },
  },
});

export const { setRealityCheck, hideRealityCheck } = realityCheck.actions;

export default realityCheck;
